import { ImgHTMLAttributes } from 'react';

const LazyImage = ({
  src,
  className,
  alt,
  ...rest
}: ImgHTMLAttributes<HTMLImageElement | HTMLSpanElement>) => {
  if (src) {
    return (
      <img src={src} className={className} loading="lazy" {...rest} alt={alt} />
    );
  }

  return (
    <span className={`${className} bg-gray-300 animate-pulse`} {...rest} />
  );
};

export default LazyImage;
